<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <el-form
                :model="userForm"
                label-position="left"
                ref="formRef"
                label-width="100px"
                :rules="formRules"
                class="demo-ruleForm"
                style="width:96%"
              >
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>基本信息</span>
                  </div>
                  <el-form-item label="姓名" prop="name">
                    <el-input
                      v-model="userForm.name"
                      size="small"
                      placeholder="请输入姓名"
                      style="width:85%"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="身份证" prop="cardno">
                    <el-input
                      v-model="userForm.cardno"
                      size="small"
                      placeholder="请输入身份证"
                      style="width:85%"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="性别" prop="sex">
                    <el-select
                      v-model="userForm.sex"
                      placeholder="请选择性别"
                      size="small"
                      style="width:85%"
                      clearable
                      :popper-append-to-body="false"
                    >
                      <el-option label="男" :value="1"></el-option>
                      <el-option label="女" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="联系地区" required>
                    <el-select
                      v-model="userForm.province_id"
                      placeholder="请选择省份"
                      @change="getCity"
                      style="width:28%"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in provinceLists"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="userForm.city_id"
                      placeholder="请选择城市"
                      @change="getCounty"
                      :clearable="true"
                      style="width:28%"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in cityLists"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="userForm.county_id"
                      placeholder="请选择县/区"
                      @change="setCounty"
                      style="width:28%"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in countyLists"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="详细地址" prop="address">
                    <el-input
                      v-model="userForm.address"
                      size="small"
                      placeholder="请输入详细地址"
                      style="width:85%"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="眼疾" prop="eye_disease">
                    <el-select
                      v-model="userForm.eye_disease"
                      placeholder="请选择眼疾"
                      size="small"
                      style="width:85%"
                      clearable
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="(item,index) in eyeDisease"
                        :key="index"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="眼别" prop="eye_separation">
                    <el-select
                      v-model="userForm.eye_separation"
                      placeholder="请选择眼别"
                      size="small"
                      style="width:85%"
                      clearable
                      :popper-append-to-body="false"
                    >
                      <el-option label="左眼" :value="1"></el-option>
                      <el-option label="右眼" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="贫困类型" prop="poor_type">
                    <el-select
                      v-model="userForm.poor_type"
                      placeholder="请选择贫困类型"
                      size="small"
                      style="width:85%"
                      clearable
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="(item,index) in poorType"
                        :key="index"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="申请时间" prop="apply_time">
                    <el-date-picker
                      v-model="userForm.apply_time"
                      align="right"
                      type="date"
                      placeholder="选择申请日期"
                      :picker-options="pickerOptions"
                      style="width:85%"
                    ></el-date-picker>
                  </el-form-item>
                </el-card>
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>资料上传</span>
                  </div>
                  <div>
                    <el-upload
                      ref="imgUploadPic1"
                      :action="uploadImgUrl"
                      :limit="2"
                      list-type="picture-card"
                      :data="uploadParms"
                      :on-preview="handlePictureCardPreview"
                      :on-success="onSuccess1"
                      :on-remove="onRemove1"
                      name="img"
                      :before-upload="beforeUpload"
                      :on-exceed="onExceed"
                      style="margin-bottom:10px"
                      :file-list="fileLists.cardno_pics"
                    >
                      <i class="el-icon-plus">
                        <span>身份证明</span>
                      </i>
                    </el-upload>
                  </div>

                  <el-upload
                    ref="imgUploadPic2"
                    :action="uploadImgUrl"
                    list-type="picture-card"
                    :data="uploadParms"
                    :on-preview="handlePictureCardPreview"
                    :on-success="onSuccess2"
                    :on-remove="onRemove2"
                    name="img"
                    :before-upload="beforeUpload"
                    style="margin-bottom:10px"
                    :file-list="fileLists.poor_pics"
                  >
                    <i class="el-icon-plus">贫困证明</i>
                  </el-upload>

                  <el-upload
                    ref="imgUploadPic3"
                    :action="uploadImgUrl"
                    list-type="picture-card"
                    :data="uploadParms"
                    :on-preview="handlePictureCardPreview"
                    :on-success="onSuccess3"
                    :on-remove="onRemove3"
                    name="img"
                    :before-upload="beforeUpload"
                    :file-list="fileLists.settlement_pics"
                  >
                    <i class="el-icon-plus">结算图片</i>
                  </el-upload>
                  <div>
                    <span style="color:red">结算图片</span>请参照
                    <span style="color:blue;cursor:pointer;" @click="openImg(1)">发票样板</span>，
                    <span style="color:blue;cursor:pointer;" @click="openImg(2)">费用清单样板</span>
                    提供结算图片
                  </div>

                  <el-upload
                    ref="imgUploadPic5"
                    :action="uploadImgUrl"
                    list-type="picture-card"
                    :data="uploadParms"
                    :on-preview="handlePictureCardPreview"
                    :on-success="onSuccess5"
                    :on-remove="onRemove5"
                    name="img"
                    :before-upload="beforeUpload"
                    style="margin-bottom:10px"
                    :file-list="fileLists.other_pics"
                  >
                    <i class="el-icon-plus">其他证明</i>
                  </el-upload>
                </el-card>
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>关联推荐</span>
                  </div>
                  <el-form-item label="是否推荐" prop="ifrecommend">
                    <el-switch
                      v-model="userForm.ifrecommend"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="1"
                      :inactive-value="2"
                    ></el-switch>
                  </el-form-item>
                  <div v-if="userForm.ifrecommend == 1">
                    <el-form-item label="推荐链接" prop="recommend_url">
                      <el-input
                        v-model="userForm.recommend_url"
                        size="small"
                        placeholder="请输入http://或https://链接"
                        style="width:85%"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="推荐描述" prop="recommend_desc">
                      <el-input
                        v-model="userForm.recommend_desc"
                        size="small"
                        placeholder="请输入推荐描述"
                        style="width:85%"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="推荐图片" prop="recommend_pics">
                      <el-upload
                        ref="imgUploadPic4"
                        :action="uploadImgUrl"
                        list-type="picture-card"
                        :data="uploadParms"
                        :on-preview="handlePictureCardPreview"
                        :on-success="onSuccess4"
                        :on-remove="onRemove4"
                        name="img"
                        :before-upload="beforeUpload"
                        style="margin-bottom:10px"
                        :file-list="fileLists.recommend_pics"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </div>
                </el-card>
                <el-form-item style="float:right">
                  <el-button @click="saveReporting(0)">保存草稿</el-button>
                  <el-button type="primary" @click="saveReporting(1)">上报申请</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-dialog :visible.sync="modalImg1" title="发票样板">
              <img src="../../../assets/images/fpyb.jpg" alt style="width:100%" />
            </el-dialog>
            <el-dialog :visible.sync="modalImg2" title="费用清单样板">
              <img src="../../../assets/images/fyqd.jpg" alt style="width:100%" />
            </el-dialog>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import "@/components/Hospital/public/poster.less";
import Axios from "axios";
import myHead from "@/components/Hospital/public/head";
import centerHead from "@/components/Hospital/public/center_head";
import leftMenu from "@/components/Hospital/public/menu";
import footDiv from "@/components/Hospital/public/foot";
export default {
  name: "reportEdit",
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          var date = new Date("2017-8-17").getTime();
          return time.getTime() < date;
        }
      },
      userForm: {
        ifrecommend: 2,
        cardno_pics: [],
        poor_pics: [],
        settlement_pics: [],
        recommend_pics: [],
        other_pics: []
      },
      fileLists: {
        cardno_pics: [],
        poor_pics: [],
        settlement_pics: [],
        other_pics: [],
        recommend_pics: []
      },
      formRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        cardno: [
          { required: true, message: "请输入身份证号码", trigger: "blur" }
        ],
        sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        eye_disease: [
          { required: true, message: "请选择眼疾", trigger: "change" }
        ],
        eye_separation: [
          { required: true, message: "请选择眼别", trigger: "change" }
        ],
        poor_type: [
          { required: true, message: "请选择贫困类型", trigger: "change" }
        ],
        apply_time: [
          { required: true, message: "请选择申请时间", trigger: "change" }
        ],
        ifrecommend: [
          {
            required: true,
            type: "number",
            message: "请选择是否推送",
            trigger: "change"
          }
        ],
        recommend_url: [
          { required: true, message: "请输入推荐链接", trigger: "blur" }
        ],
        recommend_desc: [
          { required: true, message: "请选择推荐描述", trigger: "blur" }
        ],
        recommend_pics: [
          {
            required: true,
            type: "array",
            message: "请选择推荐描述",
            trigger: "change"
          }
        ]
      },
      uploadImgUrl: "", // 上传到图片的地址
      uploadParms: { file_type: 2 }, //图片上传所需参数
      uploadPicParams: {}, // 上传图片对象
      eyeDisease: [], // 眼疾
      poorType: [], // 贫困类型
      provinceLists: [], //省集合
      cityLists: [], //市集合
      countyLists: [], //县集合
      modalImg1: false,
      modalImg2: false
    };
  },
  methods: {
    getCity(value, isEdit = false) {
      if (!isEdit) {
        this.userForm.city_id = null;
        this.userForm.county_id = null;
      }
      this.countyLists = []; // 清空县的数组

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.cityLists = resp.data;
          }
        });
    },
    getCounty(value, isEdit = false) {
      if (!isEdit) {
        this.userForm.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.countyLists = resp.data;
          }
        });
    },
    setCounty(val) {
      this.$forceUpdate(); // 强制刷新，解决选中值没反应的情况
    },
    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },
    handlePictureCardPreview() {
      // 暂时不用
    },
    onSuccess1(res, file, fileList) {
      this.updatePicArr(fileList, "cardno_pics", this.userForm);
    },
    onSuccess2(res, file, fileList) {
      this.updatePicArr(fileList, "poor_pics", this.userForm);
    },
    onSuccess3(res, file, fileList) {
      this.updatePicArr(fileList, "settlement_pics", this.userForm);
    },
    onSuccess4(res, file, fileList) {
      this.updatePicArr(fileList, "recommend_pics", this.userForm);
    },
    onSuccess5(res, file, fileList) {
      this.updatePicArr(fileList, "other_pics", this.userForm);
    },
    onRemove1(file, fileList) {
      this.updatePicArr(fileList, "cardno_pics", this.userForm, true);
    },
    onRemove2(file, fileList) {
      this.updatePicArr(fileList, "poor_pics", this.userForm, true);
    },
    onRemove3(file, fileList) {
      this.updatePicArr(fileList, "settlement_pics", this.userForm, true);
    },
    onRemove4(file, fileList) {
      this.updatePicArr(fileList, "recommend_pics", this.userForm, true);
    },
    onRemove5(file, fileList) {
      this.updatePicArr(fileList, "other_pics", this.userForm, true);
    },
    /**
     * 新增 删除 图片啊
     * @param Array fileList 上传成功或者删除成功的回调
     * @param String name 需要提交的对象中的哪个数组名字
     * @param Object objName 需要提交的哪个对象
     * @param Boolean remove 是否是删除
     */
    updatePicArr(fileList, name, objName, remove = false) {
      if (remove) {
        let arr = [];
        fileList.forEach(item => {
          arr.push(item.response.data.id);
        });
        objName[name] = arr;
      } else {
        let index1 = fileList.length - 1; // 记录数组位置
        if (objName[name].length > 0) {
          objName[name].some((item, index) => {
            if (objName[name][index] == fileList[index1].response.data.id) {
              fileList = fileList.pop(); // 删除最后一个元素
              this.$message.error("请不要上传相同文件");
              return true; // 终止循环
            }
          });
          if (fileList[index1]) {
            objName[name].push(fileList[index1].response.data.id);
          }
        } else {
          objName[name].push(fileList[index1].response.data.id);
        }
      }
    },
    openImg(type) {
      if (type == 1) {
        // 发票样板
        this.modalImg1 = true;
      } else {
        // 费用清单样板
        this.modalImg2 = true;
      }
    },
    onExceed(file, fileList) {
      this.$message.error(
        "请上传身份证(正反面)照片或户口簿(户主页和本人页)照片"
      );
    },
    getDetails() {
      this.$db
        .post("report-getReportDetail", { id: this.$route.params.id })
        .then(res => {
          let cardno_pics = [],
            poor_pics = [],
            settlement_pics = [],
            other_pics = [],
            recommend_pics = [];
          this.userForm = res.data;
          // 省市县
          if (res.data.province_id) {
            this.userForm.province_id = res.data.province_id;
            this.getCity(this.userForm.province_id, true);
          }

          if (res.data.city_id) {
            this.userForm.city_id = res.data.city_id;
            this.getCounty(this.userForm.city_id, true);
          }

          if (res.data.county_id) {
            this.userForm.county_id = res.data.county_id;
          }

          this.userForm.cardno_pics.forEach(item => {
            cardno_pics.push(item.id);
          });
          this.userForm.poor_pics.forEach(item => {
            poor_pics.push(item.id);
          });
          this.userForm.settlement_pics.forEach(item => {
            settlement_pics.push(item.id);
          });
          this.userForm.other_pics.forEach(item => {
            other_pics.push(item.id);
          });
          this.userForm.recommend_pics.forEach(item => {
            recommend_pics.push(item.id);
          });

          for (const key in res.data) {
            // 编辑之前的图片fileLists数组
            if (res.data[key] instanceof Array) {
              this.fileLists[key] = res.data[key];
            }
          }
          // 这一块代码要放在后面 fileList之前需要绑定的数据 要在处理数据赋值之后重新赋值
          this.userForm.cardno_pics = cardno_pics;
          this.userForm.poor_pics = poor_pics;
          this.userForm.settlement_pics = settlement_pics;
          this.userForm.other_pics = other_pics;
          this.userForm.recommend_pics = recommend_pics;
        });
    },
    saveReporting(type) {
      // 保存 || 上报申请
      if (type == 0) {
        // 保存草稿
        this.userForm.status = 0;
      } else {
        // 上报申请
        this.userForm.status = 1;
      }
      this.userForm.id = this.$route.params.id;
      if (this.userForm.cardno_pics.length < 2) {
        this.$message({
          showClose: true,
          type: "error",
          message: "请上传身份证(正反面)照片或户口簿(户主页和本人页)照片"
        });
        return;
      }
      // 如果没有其他证明 贫困证明和其他证明都没有上传的情况下
      if (
        !(
          this.userForm.other_pics.length ||
          (this.userForm.poor_pics.length &&
            this.userForm.settlement_pics.length)
        )
      ) {
        return this.$message.error("请上传贫困证明和结算证明或其他证明");
      } else {
        this.$refs.formRef.validate(valid => {
          if (valid) {
            this.$db
              .post("/report-editReportApply", this.userForm)
              .then(res => {
                if (res.code == 200) {
                  this.$message.success(res.msg);
                  setTimeout(() => {
                    this.$router.push({ name: "report" });
                  }, 1000);
                }
              });
          } else {
            this.$message.error("请将表单填写完整！");
          }
        });
      }
    }
  },
  created() {
    this.$db
      .post(this.$db.config.getDictParam, {
        pid: 100170,
        table: "pub_type_param"
      })
      .then(res => {
        // 眼疾
        this.eyeDisease = res.data;
      });
    this.$db
      .post(this.$db.config.getDictParam, {
        pid: 100380,
        table: "pub_type_param"
      })
      .then(res => {
        // 贫困类型
        this.poorType = res.data;
      });

    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then(resp => {
      if (resp && resp.code == 200) {
        this.provinceLists = resp.data;
      }
    });

    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl; // 图片上传地址
    if (this.$route.params.id) {
      this.getDetails();
    } else {
      this.$message.error("参数错误");
      setTimeout(() => {
        this.$router.push({ name: "report" });
      }, 1000);
    }
  }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    // max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
  .padding {
    padding: 8px 0;
  }
  .font-color {
    color: #606266;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/Report/edit.vue